import { Injectable, NgZone } from '@angular/core';
import { MessageService } from 'primeng/api';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  constructor(private zone: NgZone, private messageService: MessageService) {}

  showSuccess(summary: string, detail: string): void {
    this.zone.run(() => {
      this.messageService.add({ severity: 'success', summary, detail });
    });
  }

  showError(summary: string, detail: string): void {
    this.zone.run(() => {
      this.messageService.add({ severity: 'error', summary, detail });
    });
  }
}
